import TopMenu from "../../TopMenu";
import MainDashboardLayout from "../../../../Layout/MainDashboardLayout";
import React, { useState, useEffect, useRef } from "react";
import { Box } from "@mui/material";
import { companyId } from "../../../../utils/companyId";
import TableDocument from "../../TableDocument";
import { get } from "../../../../utils/api";
import FilterModal from "../../../../Components/Common/FilterModal";
import { useUser } from "../../../../context/AuthContext";
import ApprovalSidebar from "../../../../Layout/ApporvalSidebar";
import MessagePopup from "../../../../Components/Masters/MessagePopup";
import ViewDetailsDrawerFacility from "../../ViewDetailsDrawerFacility";
import ViewDetailsDrawerRenewableEnergy from "./ViewDetailsDrawerRenewableEnergy";
import ViewDetailsDrawerLowCarbonProduct from "./ViewDetailsDrawerLowCarbonProduct";

const CarbonAvoidance = () => {
  const { user } = useUser();
  const [snackOpen, setsnackOpen] = useState({
    open: false,
    message: "",
    severity: "",
  });
  const currentDate = new Date();
  const currentYear = currentDate.getFullYear();

  const [selectedFacility, setSelectedFacility] = useState([]);
  const [selectedOption, setSelectedOption] = useState("");
  const [searchQuery, setSearchQuery] = useState("");
  const [url, setUrl] = useState(
    "/scope4/renewable-energy-export-avoidance/renewableEnergyExportApprovalList"
  );
  const [filterObj, setFilterObj] = useState({});
  const [filterOptions, setFilterOptions] = useState({});
  const [Doc, setDoc] = useState([]);
  const [isFilterModalOpen, setIsFilterModalOpen] = useState(false);
  const [fromDate, setFromDate] = useState({
    month: 1,
    year: currentYear,
  });
  const [toDate, setToDate] = useState({
    month: currentDate.getMonth() + 1,
    year: currentYear,
  });
  const [approvalUrl, setApprovalUrl] = useState(
    "/scope4/renewable-energy-export-avoidance/renewableEnergyExportApproveOrReject"
  );

  const toggleData = [
    {
      title: "Renewable Energy Export Avoidance",
      url: "/scope4/renewable-energy-export-avoidance/renewableEnergyExportApprovalList",
      approvalUrl:
        "/scope4/renewable-energy-export-avoidance/renewableEnergyExportApproveOrReject",
    },
    {
      title: "Low Carbon Product Use",
      url: "/scope4/lower-carbon-product/lowCarbonProductApprovalList",
      approvalUrl:
        "/scope4/lower-carbon-product/lowCarbonProductApproveOrReject",
    },
  ];

  const heading = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    // {
    //   title: "Type of Renewable Energy",
    //   key: "typeOfRenewableEnergy",
    // },
    {
      title: "Energy Exported",
      key: "energyExported",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const heading2 = [
    {
      title: "Entry Date",
      key: "createdAt",
    },
    user?.companyAdmin
      ? {
          title: "Facility",
          key: "facilityName",
        }
      : null,
    {
      key: "consumptionPeriod",
      title: "Consumption Month",
    },
    // {
    //   title: "Product Name",
    //   key: "productName",
    // },
    // {
    //   title: "Conventional Product",
    //   key: "conventionalProductName",
    // },
    {
      title: "Quantity Sold",
      key: "quantitySold",
    },
    {
      title: "Status",
      key: "requestStatus",
    },
    {
      title: "CreatedBy",
      key: "createdBy",
    },
  ].filter(Boolean);

  const viewheadersEquipment = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "typeOfRenewableEnergy", title: "Type of Renewable Energy" },
    { key: "importer", title: "Importer" },
    { key: "energyExported", title: "Energy Exported" },
    { key: "emissionFactor", title: "Emission Factor" },
    // { key: "totalEmission", title: "Total Emission" },
    { key: "remarks", title: "Remarks" },
    // { key: "editRemarkReason", title: "Edit Remark Reason" },
  ];

  const viewheadersFacility = [
    { key: "consumptionPeriod", title: "Consumption Period" },
    { key: "productName", title: "Product Name" },
    { key: "conventionalProductName", title: "Conventional Product" },
    { key: "quantitySold", title: "Quantity Sold" },
    { key: "unit", title: "Unit" },
    {
      key: "emissionFactorConventionalProduct",
      title: "Conventional Product Emission Factor",
    },
    { key: "emissionFactorProductSold", title: "Product Sold Emission Factor" },
    { key: "remarks", title: "Remarks" },
    // { key: "editRemarkReason", title: "Edit Remark Reason" },
  ];

  const [toggleHeding, SetHeading] = useState(heading);
  const [data, setData] = useState([]);
  const [sortConfig, setSortConfig] = useState({
    key: "updatedAt",
    direction: "desc",
  });
  const tableContainerRef = useRef(null);
  const [isShortContent, setIsShortContent] = useState(false);

  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [appliedFilters, setAppliedFilters] = useState({
    Date: false,
    "Type of Renewable Energy": false,
    "Product Name": false,
  });
  const [limit] = useState(10);
  const [selectedFilter, setSelectedFilter] = useState("Date");
  const [drawerFilterOpen, setDrawerFilterOpen] = useState(false);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [errors, setErrors] = useState({});
  const [selectedMonth, setSelectedMonth] = useState("");
  const [selectedYear, setSelectedYear] = useState("");
  const [uniqueValues, setUniqueValues] = useState({});
  const [isFiltersApplied, setIsFiltersApplied] = useState(false);
  const [selectedFields, setSelectedFields] = useState({
    typeOfRenewableEnergy: [],
    productName: [],
  });
  const [columnWidth, setcolumnWidth] = useState(
    user?.companyAdmin ? "12% 15% 15% 15% 15% 16% 8%" : "12% 20% 20% 18% 18% 8%"
  );
  const filters = ["Date", "Type of Renewable Energy", "Product Name"];

  const fetchUniqueValues = async () => {
    try {
      const response = await get(url);
      const data = response.data.data;

      if (selectedOption === "Renewable Energy Export Avoidance") {
        const uniqueTypeOfRenewableEnergy = [
          ...new Set(
            data.map((el) => el.typeOfRenewableEnergy).filter(Boolean)
          ),
        ];
        const uniqueImporter = [
          ...new Set(data.map((el) => el.importer).filter(Boolean)),
        ];
        setFilterOptions({
          typeOfRenewableEnergy: uniqueTypeOfRenewableEnergy,
          importer: uniqueImporter,
        });
        return {
          typeOfRenewableEnergy: uniqueTypeOfRenewableEnergy,
          importer: uniqueImporter,
        };
      } else {
        const uniqueProductName = [
          ...new Set(data.map((el) => el.productName).filter(Boolean)),
        ];
        const uniqueConventionalProduct = [
          ...new Set(
            data.map((el) => el.conventionalProductName).filter(Boolean)
          ),
        ];
        setFilterOptions({
          productName: uniqueProductName,
          conventionalProduct: uniqueConventionalProduct,
        });
        return {
          productName: uniqueProductName,
          conventionalProduct: uniqueConventionalProduct,
        };
      }
    } catch (error) {
      console.error("Error fetching unique values:", error);
      return {};
    }
  };

  useEffect(() => {
    fetchData();
  }, [
    page,
    rowsPerPage,
    sortConfig,
    searchQuery,
    filterObj,
    url,
    fromDate,
    toDate,
    selectedFacility,
  ]);

  const fetchData = async (filters = filterObj) => {
    try {
      const queryParams = new URLSearchParams({
        ...filters,
        page,
        limit: rowsPerPage,
        sortField: sortConfig.key,
        sortOrder: sortConfig.direction,
        company: companyId,
        createdBy: companyId,
        search: searchQuery,
        facilityList: selectedFacility.join(","),
      }).toString();

      const response = await get(`${url}?${queryParams}`);
      setData(response.data.data);
      setDoc(response.data.data);
      setTotalPages(response.data.totalPages);
      setPage(response.data.currentPage);
      const uniqueValues = await fetchUniqueValues();
      setUniqueValues(uniqueValues);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  const filterData = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Type of Renewable Energy",
      type: "option",
      key: "typeOfRenewableEnergy",
      value: filterOptions.typeOfRenewableEnergy,
    },
    {
      title: "Importer",
      type: "option",
      key: "importer",
      value: filterOptions.importer,
    },
  ];

  const filterData2 = [
    { title: "Date", type: "date", key: "createdAt", value: [] },
    {
      title: "Product Name",
      type: "option",
      key: "productName",
      value: filterOptions.productName,
    },
    {
      title: "Conventional Product",
      type: "option",
      key: "conventionalProductName",
      value: filterOptions.conventionalProduct,
    },
  ];

  const handleFilterChange = (newFilterObj) => {
    if (selectedOption === "Renewable Energy Export Avoidance") {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    } else {
      setFilterObj((prev) => ({
        ...prev,
        ...newFilterObj,
      }));
    }
  };

  useEffect(() => {
    const container = tableContainerRef.current;
    if (container) {
      const tableHeight = container.scrollHeight;
      const screenHeight = window.innerHeight;
      setIsShortContent(tableHeight < screenHeight / 3);
    }
  }, [data]);

  const handleToggle = (option, url, approvalUrl) => {
    setSelectedOption(option);
    setUrl(url);
    setApprovalUrl(approvalUrl);

    SetHeading(
      toggleData?.[0]?.title === option
        ? heading
        : toggleData?.[1]?.title === option
        ? heading2
        : null
    );

    setcolumnWidth(
      toggleData?.[0]?.title === option
        ? user?.companyAdmin
          ? "12% 15% 15% 15% 15% 16% 8%"
          : "12% 20% 20% 18% 18% 8%"
        : user?.companyAdmin
        ? "11% 14% 13% 12% 13% 11% 14% 8%"
        : "12% 20% 20% 18% 18% 8%"
    );
  };

  useEffect(() => {
    setSelectedOption(toggleData?.[0].title);
    setUrl(toggleData?.[0].url);
    setApprovalUrl(toggleData?.[0].approvalUrl);
  }, []);

  const fetchDataCallback = async () => {
    await fetchData();
  };

  return (
    <MainDashboardLayout sidebar={<ApprovalSidebar />}>
      <>
        <MessagePopup {...{ snackOpen, setsnackOpen }} />
        <TopMenu
          {...{
            setDrawerFilterOpen: setIsFilterModalOpen,
            selectedMonth,
            setSelectedMonth,
            selectedYear,
            setSearchQuery,
            setSelectedYear,
            selectedOption,
            handleToggle,
            filterApplied: isFilterModalOpen,
            toggleData,
            fromDate,
            setFromDate,
            toDate,
            setToDate,
            selectedFacility,
            setSelectedFacility,
          }}
          heading={"Carbon Avoidance"}
        />
        <Box
          sx={{
            backgroundColor: "#ededed",
          }}
        >
          <TableDocument
            data={data}
            page={page}
            totalPages={totalPages}
            headers={toggleHeding}
            columnWidth={columnWidth}
            setsnackOpen={setsnackOpen}
            fetchDataCallback={fetchDataCallback}
            apiUrl={approvalUrl}
            viewheaders={
              selectedOption === "Renewable Energy Export Avoidance"
                ? viewheadersEquipment
                : viewheadersFacility
            }
            viewPage={
              selectedOption === "Renewable Energy Export Avoidance"
                ? ViewDetailsDrawerRenewableEnergy
                : selectedOption === "Low Carbon Product Use"
                ? ViewDetailsDrawerLowCarbonProduct
                : null
            }
          />
        </Box>
        <FilterModal
          isOpen={isFilterModalOpen}
          onClose={() => setIsFilterModalOpen(false)}
          filters={
            selectedOption === "Renewable Energy Export Avoidance"
              ? filterData
              : filterData2
          }
          onFilterChange={handleFilterChange}
          title="Filter"
        />
      </>
    </MainDashboardLayout>
  );
};

export default CarbonAvoidance;
